import functionUncurryThis from './function-uncurry-this.js';

var uncurryThis = functionUncurryThis; // `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue

var thisNumberValue = uncurryThis(1.0.valueOf);

export { thisNumberValue as default };
